{
  "slug": "iq-vs-eq",
  "title": "IQ مقابل EQ: ما هو الفرق؟",
  "description": "مقارنة الذكاء والذكاء العاطفي، بما في ذلك ما يشمله كل مفهوم، وكيف يتم قياسهما، وحدودهما.",
  "summary": "يركز معدل الذكاء على قدرات معرفية مختارة. ويتعلق الذكاء العاطفي بإدراك العاطفة وفهمها واستخدامها والتعامل معها. ولا يتداخل هذان الجانبان إلا جزئيا.",
  "sections": [
    {
      "heading": "ماذا يصف معدل الذكاء ومعدل الكفاءة",
      "paragraphs": [
        "إن اختبارات الذكاء تشمل اختبارات التفكير، والمعرفة، والذاكرة العاملة، والمعالجة البصرية المكانية، والسرعة. وتركز نماذج الذكاء العاطفي على التعرف على المشاعر، وفهم المعلومات العاطفية، وتنظيم الاستجابات، والتنقل في المواقف بين الأشخاص.",
        "غالبا ما يستخدم المختصر EQ مثل IQ، ولكن الذكاء العاطفي ليس له مقياس واحد مقبول عالميا أو نظام لتحديد الدرجات."
      ]
    },
    {
      "heading": "كيف يختلف القياس",
      "paragraphs": [
        "إن اختبارات الذكاء الاصطناعي تعتمد على اختبارات الأداء القياسية والمعايير القائمة على العمر. أما الذكاء العاطفي فقد يستخدم مهام القدرات، أو استبيانات التقرير الذاتي، أو تقارير من أشخاص آخرين. وهذه الأساليب تجمع بين أمور مختلفة.",
        "ويمكن أن تعكس مقاييس الإبلاغ الذاتي تصورات الذات وأسلوب الاستجابة. وتواجه الاختبارات العاطفية القائمة على القدرات أسئلة حول أفضل استجابة موضوعية في المواقف الاجتماعية المعقدة."
      ]
    },
    {
      "heading": "لماذا يمكن أن يكون كلاهما مهما",
      "paragraphs": [
        "إن المهارات المعرفية تساعد الناس على التعلم، وتحليل، وحل المشاكل الجديدة. والمهارات العاطفية والاجتماعية تدعم التواصل، والعمل الجماعي، وإدارة الصراعات، والرفاهة.",
        "ولا يحدد أي من الدرجات الشخص. فالنتائج تعتمد على القدرة، والشخصية، والدوافع، والمعرفة، والصحة، والسياق، والفرص."
      ]
    }
  ],
  "faqs": [
    {
      "question": "هل EQ أهم من IQ؟",
      "answer": "لا يوجد فائز عالمي. فالأهداف المختلفة تتطلب تركيبات مختلفة من المهارات المعرفية والعاطفية والعملية والاجتماعية."
    },
    {
      "question": "هل يمكن تحسين EQ؟",
      "answer": "ويمكن ممارسة مهارات مثل مفردات العواطف، واعتماد المنظور، واستراتيجيات التنظيم، على الرغم من أن النتائج تتوقف على السياق."
    }
  ],
  "related": ["iq-vs-intelligence", "what-is-iq", "can-iq-change-over-time"]
}
